import { Settings } from "./Settings";

export function Dashboard() {
  return (
    <>
      <Settings />
    </>
  );
}
